import React from 'react';
import '../styles/main.scss';

import Navbar from './Navbar';
import About from './About';
import Tech from './Technologies/Tech';
import Projects from './Projects/Projects';
import Footer from './Footer';

function App() {
  return (
    <div>
      <Navbar />
      <About />
      <Tech />
      <Projects />
      <Footer />
    </div>
  );
}

export default App;
